export interface FutureEventModel {
    dateTime?: string;
    eventType?: string
    communicationType: CommunicationType
    note : string
}

export enum CommunicationType {
    "Face to face",
    "Online meeting",
    "Phone call",
    "Email",
}